import {
  SequenceCommentZone,
  SequenceTextbox,
} from "../../models/interactions/Sequence";

export type FlowPoint = { x: number; y: number };
export type FlowRect = FlowPoint & { width: number; height: number };

export function normalizeFlowRect(start: FlowPoint, end: FlowPoint): FlowRect {
  return {
    x: Math.min(start.x, end.x),
    y: Math.min(start.y, end.y),
    width: Math.abs(end.x - start.x),
    height: Math.abs(end.y - start.y),
  };
}

export function rectsIntersect(left: FlowRect, right: FlowRect): boolean {
  return (
    left.x <= right.x + right.width &&
    left.x + left.width >= right.x &&
    left.y <= right.y + right.height &&
    left.y + left.height >= right.y
  );
}

export function rectContains(outer: FlowRect, inner: FlowRect): boolean {
  return (
    inner.x >= outer.x &&
    inner.y >= outer.y &&
    inner.x + inner.width <= outer.x + outer.width &&
    inner.y + inner.height <= outer.y + outer.height
  );
}

export function getAnnotationIdsInMarquee(
  rect: FlowRect,
  commentZones: SequenceCommentZone[],
  textboxes: SequenceTextbox[],
): { commentZoneIds: string[]; textboxIds: string[] } {
  return {
    commentZoneIds: commentZones
      .filter((zone) =>
        rectContains(rect, {
          ...zone.position,
          ...zone.size,
        }),
      )
      .map((zone) => zone.id),
    textboxIds: textboxes
      .filter((textbox) =>
        rectsIntersect(rect, {
          ...textbox.position,
          ...textbox.size,
        }),
      )
      .map((textbox) => textbox.id),
  };
}
